<mat-form-field [formGroup]="formgroup!" class="search-form-field">
    <input matInput [placeholder]="t7eLabel" [formControl]="searchFC!">
</mat-form-field>